<template>
  <div class="bg-white">
    <div class="page-landing:text-white page-landing:bg-petrol">
      <NuxtPageDependency>
        <PageHeader />
      </NuxtPageDependency>
      <div>
        <slot />
      </div>
      <SearchBar />
      <PageFooter />
    </div>
  </div>
</template>

<script setup lang="ts">
useHead({
  title: '404 | AOZ',
})
</script>
